module.exports = __webpack_public_path__ + "static/media/27OCHA12.2657ce43.jpg";